import SigninForm from '../model/form.model';

const TYPE_MEMBER = 'MBR';
const TYPE_AFFILIATE = 'AFF';

class FormController {
  constructor(SigninService, FormService, StorageService, $timeout, $state, $window, $location, $translate) {
    'ngInject';

    this.SigninService = SigninService;
    this.StorageService = StorageService;
    this.FormService = FormService;

    this.$timeout = $timeout;
    this.$state = $state;
    this.$window = $window;
    this.$translate = $translate;
    this.$location = $location;
  }

  $onInit() {
    this.form = SigninForm;
    this.autoLogin();
    this.storeOrigin = this.getOrigin.bind(this);
    this.$window.addEventListener('message', this.storeOrigin);
  }

  getOrigin(e) {
    let parsedData = e.data;
    if (parsedData) {
      this.StorageService.setItem('site_origin', parsedData.origin_from);
      if (parsedData.username && parsedData.password) {
        this.form._username = parsedData.username;
        this.form._password = parsedData.password;
        this.submit();
      }
    }
  }

  autoLogin() {
    if (this.$location.search().username && this.$location.search().password) {
      this.form._username = this.$location.search().username;
      this.form._password = this.$location.search().password;
      this.$timeout(() => {
        this.submit();
      }, 1500);
    }
  }

  submit() {
    var spinner = document.getElementById('spin');
    spinner.classList.remove("hidden");

    this.form.error = '';
    this.FormService.isSubmitting.next(true);
    this.SigninService.signin(this.form.toPayload())
    .then((sessionDetails) => {
      this.$translate.use(sessionDetails.locale);

      if (sessionDetails.tags.includes(TYPE_AFFILIATE)) {
        parent.postMessage('amsLogin-affiliate', '*' );
        this.StorageService.setItem('customer_type', TYPE_AFFILIATE);
        this.$state.go('marketing');
      } else {
        parent.postMessage('amsLogin-member', '*' );
        this.StorageService.setItem('customer_type', TYPE_MEMBER);
        this.$state.go('dashboard');
      }
      this.$timeout(() => { this.$window.location.reload(); }, 500);
    })
    .catch((error) => {
      // needed to use timeout, probably another issue on $digest.
      this.$timeout(() => this.form.error = error, 100);
      spinner.classList.add("hidden");
    })
    .finally(() => this.FormService.isSubmitting.next(false))
    ;
  }

  sendPostMessageToForgotPass() {
    parent.postMessage('amsForgot-pass', '*');
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/signin/component/form.controller.js